<template>
  <div
    class="numeric-entry-component-container"
    :class="{ 'full-page': leftColumn }"
  >
    <div
      v-if="answered"
      class="answered"
      @click="$emit('click', firstAnswer.id)"
    >
      <label>Answer:</label>
      <div class="answer selected">
        <radio-button
          :answered="true"
          :selected="true"
          :correct="correct"
        ></radio-button>
        {{ correct ? correctAnswer : number }} {{ unit }}
      </div>
      <div
        v-if="!correct"
        class="answer"
      >
        <radio-button
          :answered="true"
          :selected="true"
          :correct="true"
        ></radio-button>
        {{ correctAnswer }} {{ unit }}
      </div>
    </div>
    <div
      v-else
      class="unanswered-wrapper"
    >
      <div class="unanswered">
        <input
          v-model="number"
          type="number"
          @blur="blur"
          @focus="focus"
        >
        <label>{{ unit }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import RadioButton from '@/components/flashcards-v2/fragments/RadioButton';

export default {
  components: { RadioButton },
  props: {
    answered: {
      type: Boolean,
      default: false,
    },
    correct: {
      type: Boolean,
      default: false,
    },
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    flashcardState: {
      type: Object,
      default: () => ({}),
    },
    leftColumn: {
      type: Boolean,
      default: false,
    },
    rawAnswerData: {
      type: Object,
    },
    highlightedAnswerId: {
      type: Number,
      default: null,
    },
  },
  emits: ['set-raw-answer-data', 'click'],
  computed: {
    firstAnswer() {
      return this.flashcard.answers[0];
    },
    correctAnswer() {
      return JSON.parse(this.flashcard.answers[0].text).numeric;
    },
    unit() {
      return JSON.parse(this.flashcard.answers[0].text).unit;
    },
    number: {
      get() {
        if (this.flashcardState.rawAnswerData) {
          return this.flashcardState.rawAnswerData.numeric;
        }
        return this.rawAnswerData ? this.rawAnswerData.numeric : null;
      },
      set(value) {
        this.$emit('set-raw-answer-data', {numeric: value});
      },
    },
  },
  watch: {
    flashcard: {
      handler(newFlash, oldFlash) {
        if (newFlash?.id !== oldFlash?.id) {
          if (!this.rawAnswerData) {
            this.$emit('set-raw-answer-data', { numeric: null });
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    blur() {
      this.$store.commit('appState/setInputtingText', false);
    },
    focus() {
      this.$store.commit('appState/setInputtingText', true);
    },
  },
};
</script>

<style lang='scss' scoped>
  .numeric-entry-component-container {
    margin: rem-calc(32) 0;

    .unanswered-wrapper {
      display: grid;
      place-content: center;
    }

    .unanswered {
      label {
        display: inline-block;
      }

      input {
        background: #dfe3e9;
        border: solid 1px rgba(0,0,0,0.1);
        border-radius: 4px;
        margin-right: rem-calc(4);
        padding: rem-calc(6);
        text-align: right;
        width: rem-calc(80);

        &::-webkit-inner-spin-button, &::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
    }

    .answered {
      label {
        font-size: rem-calc(18);
      }

      .icon {
        @include incorrect-svg(#FA726F);
        background-size: contain;
        height: rem-calc(16);
        margin-right: rem-calc(12);
        width: rem-calc(16);

        &.correct {
          @include correct-svg(#70CF63);
        }
      }

      .answer {
        align-items: center;
        display: flex;
        gap: rem-calc(8);
        margin-top: rem-calc(16);
      }

      .selected {
        font-weight: $semi-bold;
      }
    }
  }
</style>
